<template>
    <div>
        <limitless-page-header :title="'Gröda'" :buttons="[{'url':'/crops/0','text':'Ny gröda', 'icon':'icon-plus-circle2'}]"></limitless-page-header>

        <div class="content">
            <rednax-datatable :url="'/vue/crops/table'" :columns="table_columns" :filter="table_filter" @updateFilter="table_filter=$event" @rowclick="rowClick" history>
                <div class="row">
                    <div class="col-lg-3">
                        <input type="text" v-model="table_filter.search" class="form-control">
                    </div>
                </div>
            </rednax-datatable>
        </div> <!-- /content -->
    </div>
</template>

<script>
import LimitlessPageHeader from '@components/Limitless/LimitlessPageHeader';
import RednaxDatatable from '@components/RednaxDatatableComponent';

export default {
    name: 'CropList',
    components: {
        LimitlessPageHeader,
        RednaxDatatable,
    },
    data: () => ({
        table_filter: {
            search: '',
        },
        table_columns: [
            {
                header: '#',
                data: 'id',
                sortable: true,
            },
            {
                header: 'Namn',
                data: 'name',
                sortable: true,
            },
            {
                header: 'Kod',
                data: 'code',
                sortable: true,
            },
            {
                header: 'Dagar i groskåp',
                data: 'germination_days',
                sortable: true,
            },
            {
                header: 'Dagar i barnkammare',
                data: 'nursery_days',
                sortable: true,
            },
            {
                header: 'Dagar i systemet',
                data: 'system_days',
                sortable: true,
            },
            {
                header: 'Totalt antal dagar',
                data: 'total_days',
                sortable: true,
            },
        ],
    }),
    methods: {
        rowClick(row) {
            window.location.href = '/crops/' + row.id;
        },
    },
};

</script>
